
































module.exports =
  name: 'transaction_account_virtual'
  props: ['transaction', 'mode']
  computed:
    from_reserves: -> @transaction.virtual_id == @$store.getters.rs.id
    should_not_expense_from_reserves: ->
      @transaction.isExpense() && @transaction.isUnplanned() && @from_reserves && @mode == 'enter'
    should_not_plan_from_not_reserves: -> @mode == 'plan' && !@from_reserves
    account_categories: ->
      all = if @transaction.isWithHiddenAccount() then @$store.getters.account_categories else @$store.getters.account_categories_visible
      not_empty = all.filter (cat) => cat.children().length > 0
      return not_empty
    virtual_categories: ->
      all = if @transaction.isWithHiddenVirtual() then @$store.getters.virtual_categories else @$store.getters.virtual_categories_visible
      not_empty = all.filter (cat) => cat.children().length > 0
      return not_empty
